import {Locale} from '@aboutyou/config';
import {Head} from '@aboutyou/head-elements';
import {useLocale} from '@aboutyou/i18n';
import Page from '@aboutyou/legacy-desktop/src/app/pages/Welcome/WelcomePage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/Welcome/redial';
import {withLaunchTeaserRedirect} from '@aboutyou/logic-components';
import React, {StrictMode} from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

const LegacyWelcomePage = withLaunchTeaserRedirect(
  withLegacyProviders(PageWithRedial),
);

export const WelcomePage = () => {
  return (
    <>
      <StrictMode>
        <AddBecomMetaTag />
      </StrictMode>
      <LegacyWelcomePage />
    </>
  );
};

/**
 * hardcoded metatag for BE locale only
 */
const AddBecomMetaTag = () => {
  const locale = useLocale();
  if (locale !== Locale.fr_BE && locale !== Locale.nl_BE) {
    return null;
  }

  return (
    <Head>
      <meta name="tp-claim" content="429a9c1167ec2d" />
    </Head>
  );
};
